// extracted by mini-css-extract-plugin
module.exports = {"container":"NoResults_container__nNfhD","error":"NoResults_error__0jwVP"};